import navigate_to_org from 'assets/images/guides/raise-invoice/navigate-to-org-1.png';
import raise_2 from 'assets/images/guides/raise-invoice/raise-2.png';
import raise_3 from 'assets/images/guides/raise-invoice/raise-3.png';
import raise_4 from 'assets/images/guides/raise-invoice/raise-4.png';

export const raise_invoice = [
  {
    caption: 'Open `Organisations` from the menu on the left of your screen.',
    image: navigate_to_org
  },
  {
    caption: 'Find the client you want to bill, open its actions menu and select `Raise invoice`.',
    image: raise_2
  },
  {
    caption: 'Choose the plan, set your margin, then review the invoice total.',
    image: raise_3
  },
  {
    caption: 'Click `Raise invoice` then download and send the invoice to your client.',
    image: raise_4
  }
];
